import React, { Component } from 'react'
import './card.css'

export default class Card extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { title } = this.props
    return (
      <div className="card">
        <div className="container">
          <div className="title">
            {title}
          </div>
          {this.props.children}
        </div>
      </div>)
  }
}


// WEBPACK FOOTER //
// ./src/components/card/Card.jsx